import React from 'react';
import { Button } from "@/ui-components/ui/button";
import { Check, ArrowRight, CalendarClock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { format } from "date-fns";
import { de } from "date-fns/locale";

interface SuccessStateProps {
  onReset: () => void;
  scheduledDate?: Date | null;
}

export const SuccessState: React.FC<SuccessStateProps> = ({ onReset, scheduledDate }) => {
  const navigate = useNavigate();

  return (
    <div className="text-center py-12 animate-in fade-in duration-300">
      <div className={`flex h-16 w-16 items-center justify-center rounded-full border mx-auto mb-6 ${scheduledDate ? 'bg-blue-50 border-blue-100' : 'bg-green-50 border-green-100'}`}>
        {scheduledDate ? (
          <CalendarClock className="h-8 w-8 text-blue-600" />
        ) : (
          <Check className="h-8 w-8 text-green-600" />
        )}
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">
        {scheduledDate ? 'Erfolgreich eingeplant!' : 'Erfolgreich veröffentlicht!'}
      </h3>
      <p className="text-gray-500 mb-8 max-w-[280px] mx-auto">
        {scheduledDate 
          ? `Dein Post wurde erfolgreich für den ${format(scheduledDate, "d. MMMM yyyy", { locale: de })} um ${format(scheduledDate, "HH:mm", { locale: de })} Uhr eingeplant.`
          : 'Dein Post wurde erfolgreich an die ausgewählten Social Media Accounts gesendet.'}
      </p>
      
      <div className="flex flex-col gap-3 max-w-[280px] mx-auto">
        <Button 
          onClick={() => navigate('/post-generator')}
          className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-xl h-11"
        >
          Zurück zur Übersicht
        </Button>
        <Button 
          variant="outline"
          onClick={onReset}
          className="w-full border-gray-200 hover:bg-gray-50 text-gray-700 rounded-xl h-11"
        >
          Weiteren Post erstellen
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
